import { useMutation } from 'urql';
import { EventClockFragment } from '@/components/Event/EventClock/EventClock.utils';
import Select from '@/components/UI/Select';
import { type FragmentOf, graphql, readFragment } from '@/gql/graphql';

export const EventScorekeepingPanelTimerSegmentFragment =
  graphql(/* GraphQL */ `
    fragment EventScorekeepingPanelTimerSegment on event {
      id
      event_clock {
        event_id
        event_segment {
          id
          title
        }
      }
      event_segment_group {
        id
        event_segments(order_by: { order: asc_nulls_last }) {
          id
          title
        }
      }
    }
  `);

const UpdateEventSegment = graphql(/* GraphQL */ `
  mutation UpdateEventSegment($eventId: uuid!, $eventSegmentId: uuid!) {
    insert_event_clock_one(
      object: {
        event_id: $eventId
        event_segment_id: $eventSegmentId
        is_running: false
        elapsed_segment_ms: 0
        start_datetime: null
      }
      on_conflict: {
        constraint: event_clock_pkey
        update_columns: [
          event_segment_id
          is_running
          elapsed_segment_ms
          start_datetime
        ]
      }
    ) {
      event_id
      event {
        ...EventClock
      }
      event_segment {
        id
        title
      }
    }
  }
`, [EventClockFragment]);

export function EventScorekeepingPanelTimerSegment({
  fragment,
}: {
  fragment: FragmentOf<typeof EventScorekeepingPanelTimerSegmentFragment>;
}) {
  const [, updateEventSegment] = useMutation(UpdateEventSegment);
  const event = readFragment(
    EventScorekeepingPanelTimerSegmentFragment,
    fragment,
  );

  const segments = event?.event_segment_group?.event_segments || [];

  const onValueChange = async (value: string) => {
    await updateEventSegment({
      eventId: event?.id,
      eventSegmentId: value,
    });
  };

  return (
    <Select
      key={event?.event_clock?.event_segment?.id || 'select-segment'}
      value={event?.event_clock?.event_segment?.id}
      onValueChange={onValueChange}
      disabled={segments.length === 0}
      testID="ScorekeepingTimerSegmentSelect"
      width={128}
      placeholder="Select..."
      options={segments.map((segment) => ({
        label: segment.title,
        value: segment.id,
      }))}
    />
  );
}
